import ActionsMenu from '@enerex/unified-ui-react/ActionsMenu';

const MasterRateClassActionDropdown = ({ row, onEdit, onDelete }) => (
  <div className="position-static" onClick={(event) => event.stopPropagation()}>
    <ActionsMenu align="end">
      <ActionsMenu.ActionItem onClick={() => onEdit(row)} className="d-flex align-items-center gap-2">
        <i className="uil uil-edit" />
        Edit
      </ActionsMenu.ActionItem>
      <ActionsMenu.ActionItem onClick={() => onDelete(row)} className="d-flex align-items-center gap-2 text-danger">
        <i className="uil uil-trash" />
        Delete
      </ActionsMenu.ActionItem>
    </ActionsMenu>
  </div>
);

export default MasterRateClassActionDropdown;
